import JewelryCategoryComp from "../JewelryCategoryComp";
import JewelryMetalTypeComp from "../JewelryMetalTypeComp";
import { isValidMetalType } from "./isValidMetalType";
import JewelryPriceComp from "../JewelryPriceComp";
import JewelryVendorClicksComp from "../JewelryVendorClicksComp";
import JewelryRetailerClicksComp from "../JewelryRetailerClicksComp";

// One config per jewelry report, consumed by the diamond suite's shared
// ReportScaffold (src/component/ChartsGroup/DiamondReportsCharts/_shared).
// dataKey/labelField/valueField mirror reportConfigs.js's shape but point at
// a per-IndComp-page-constructed `report` object (jewelry has no single
// combined payload like LoadExtendedDiamondChartReports — each report fetches
// its own chart slice, then wraps it as { [dataKey]: rows, [totalClicksKey]: [...] }
// before handing it to ReportScaffold). hideTotalDimensionSum is set on every
// jewelry config because, unlike diamond's multi-attribute payload, a jewelry
// report's dimension-sum always equals its own Total Clicks — showing both
// would just duplicate the same number.
export const CATEGORY_CONFIG = {
  key: "category",
  dataKey: "JewelryCategorySearches",
  labelField: "Category",
  valueField: "count",
  dimensionLabel: "Category",
  pageTitle: "Jewelry Category Report",
  ChartCard: JewelryCategoryComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "category", fileNamePart: "JewelryCategoryReports" },
};

export const METAL_TYPE_CONFIG = {
  key: "metalType",
  dataKey: "JewelryMetalTypeSearches",
  labelField: "MetalType",
  valueField: "COUNT",
  dimensionLabel: "Metal Type",
  pageTitle: "Jewelry Metal Type Report",
  ChartCard: JewelryMetalTypeComp,
  noiseFilter: { isValid: isValidMetalType, toggleLabel: "Hide None / unspecified" },
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "metalType", fileNamePart: "JewelryMetalTypeReports" },
};

export const PRICE_CONFIG = {
  key: "price",
  dataKey: "JewelryPriceSearches",
  labelField: "Range",
  valueField: "total",
  dimensionLabel: "Price Band",
  pageTitle: "Jewelry Price Report",
  ChartCard: JewelryPriceComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "price", fileNamePart: "JewelryPriceReports" },
};

export const VENDOR_CLICKS_CONFIG = {
  key: "vendorClicks",
  dataKey: "JewelryVendorClicksSearches",
  labelField: "DealerCompany",
  valueField: "Total",
  dimensionLabel: "Vendor",
  pageTitle: "Jewelry Vendor Clicks Report",
  ChartCard: JewelryVendorClicksComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "vendor", fileNamePart: "JewelryVendorClicksReports" },
};

export const RETAILER_CLICKS_CONFIG = {
  key: "retailerClicks",
  dataKey: "JewelryRetailerClicksSearches",
  labelField: "dealerCompany",
  valueField: "total",
  dimensionLabel: "Retailer",
  pageTitle: "Jewelry Retailer Clicks Report",
  ChartCard: JewelryRetailerClicksComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "retailer", fileNamePart: "JewelryRetailerClicksReports" },
};
